import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import formDefault from "../../docs/formDefault.json";
import { createElement } from "commonAssets/lib/createElement";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { uniformClaimDeadline } from "commonAssets/lib/uniformClaimDeadline";
import { loading, outputDiv } from "commonAssets/js/constants";

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    init_claim(form) {
        this.claim.api
            .claimsDeadlineGet({ domain: this.claim.data.domain })
            .then((result) => {
                let claim_deadline;
                if (Boolean(result.data.claim_deadline)) {
                    claim_deadline = result.data.claim_deadline;
                }

                // Error Handling
                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                // Ops-only paper-claim entry (?paper_claim=true): credential-less
                // generic filing. The front-facing (naked) path shows the closed
                // message -- the edit-claim guard is not offered.
                const isPaperClaim =
                    new URLSearchParams(window.location.search).get(
                        "paper_claim"
                    ) === "true";

                if (isPaperClaim) {
                    const container = createElement("div", {
                        class: "display-form",
                    });
                    const deadlineSpan = uniformClaimDeadline(claim_deadline);
                    container.appendChild(this.claim_form(form, deadlineSpan));
                    outputDiv.appendChild(container);
                    this.init_claim_fields(this.claim, form, claim_deadline);
                    loadingGif(loading, "hide", 250);
                } else {
                    this.setup_result_data_error({
                        data: {
                            error: "The deadline to submit a Claim has passed.",
                        },
                    });
                }
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error fetching claim deadline", { cause: error })
                );
                this.errorHandler.display(error);
            });
    }

    claim_form(params, additionalParams) {
        const node = super.claim_form(params, additionalParams);
        node.querySelector("#claimFormDeadline")?.remove();
        return node;
    }

    init_claim_inputs() {
        const claimInputsContact =
            "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST";
        const claimInputsFields =
            "#claim-fields input, #claim-fields textarea, #claim-fields select";
        const claimInputsFieldsPayment =
            "#payment_method, #payment_token, #payment_email, #payment_phone";
        const claimInputsTransactions =
            "#transactions_1 input, #transactions_1 textarea, #transactions_1 select, #transactions_2 input, #transactions_2 textarea, #transactions_2 select, #transactions_3 input, #transactions_3 textarea, #transactions_3 select, #transactions_4 input, #transactions_4 textarea, #transactions_4 select";

        this.claim.inputs.contact = Array.from(
            document.querySelectorAll(claimInputsContact)
        );
        this.claim.inputs.fields = Array.from(
            document.querySelectorAll(
                claimInputsFields + ", " + claimInputsFieldsPayment
            )
        ).filter((field) => !field.closest("td.transaction"));
        this.claim.inputs.transactions = Array.from(
            document.querySelectorAll(claimInputsTransactions)
        );
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}
